export default __webpack_public_path__ + "static/JosefinSans-SemiBold-8b684607621c1813b5c2965dcbca9603.woff2";